@let galleries = galleries$ | async;

@if (galleries?.length || galleryPermissions().can_edit) {
  <app-section-container
    #sectionContainer
    [index]="sectionIndex"
    [gallery]="parentGallery"
    [section]="section"
    [galleryPermissions]="galleryPermissions()"
    [darkBackground]="darkBackground"
    [sections]="sections"
    [theme]="theme"
    [insideActions]="true"
    (mousemove)="mouseMove($event)"
    (mouseup)="mouseUp($event)"
    (addSection)="addSection.emit($event)"
    [class.dark-gallery-background]="darkBackground"
  >
    <ng-container sectionActionsInside>
      @if (isDesktop()) {
        <div class="spaced-button-group-item">
          <app-context-menu
            [options]="{ width: '320px', noSpacing: true }"
            [position]="'right-out'"
            [verticalPosition]="'auto-in'"
            #menu
            contextHoverIdentifier="section-{{ section.id }}"
          >
            <button
              appButton
              name="settings"
              location="edit-album-section"
              [iconButton]="true"
              height="1"
              shape="round"
              contextButton
              appTooltip="Section Settings"
              toolTipOrigin="left"
              color="simple"
            >
              <app-svg src="/assets/icons/mixer.svg"></app-svg>
            </button>
            <div contextContent>
              @if (menu.isOpen()) {
                <app-common-section-settings
                  [section]="section"
                  [gallery]="parentGallery"
                  [theme]="theme"
                ></app-common-section-settings>
              }
            </div>
          </app-context-menu>

          <app-context-menu
            [options]="{ width: '320px' }"
            [position]="'right-out'"
            [verticalPosition]="'auto-in'"
            #sortingMenu
            name="asset-section-sorting"
            contextHoverIdentifier="section-{{ section.id }}"
          >
            <button
              appButton
              name="section-sorting"
              location="edit-album-section"
              [iconButton]="true"
              height="1"
              shape="round"
              contextButton
              appTooltip="Update Order"
              toolTipOrigin="left"
              color="simple"
            >
              <app-svg src="/assets/icons/arrow-sorting.svg"></app-svg>
            </button>
            <div contextContent class="sorting-menu">
              <ng-container *ngTemplateOutlet="galleryOrderTemplate"></ng-container>
            </div>
          </app-context-menu>
        </div>
      } @else {
        <app-context-menu
          [options]="{ width: '320px', noSpacing: true }"
          #menu
          contextHoverIdentifier="section-{{ section.id }}"
        >
          <button
            appButton
            name="settings"
            location="edit-album-section"
            height="1"
            fullWidth="true"
            [hasIcon]="true"
            contextButton
            color="simple"
          >
            <app-svg src="/assets/icons/mixer.svg"></app-svg>
            <span>Options</span>
          </button>
          <div contextContent>
            @if (menu.isOpen()) {
              <app-common-section-settings
                [section]="section"
                [gallery]="parentGallery"
                [theme]="theme"
              ></app-common-section-settings>
            }
          </div>
        </app-context-menu>

        <app-context-menu
          [options]="{ width: '320px' }"
          #sortingMenu
          name="asset-section-sorting"
          contextHoverIdentifier="section-{{ section.id }}"
        >
          <button
            appButton
            name="section-sorting"
            location="edit-album-section"
            [hasIcon]="true"
            height="1"
            fullWidth="true"
            contextButton
            color="simple"
          >
            <app-svg src="/assets/icons/arrow-sorting.svg"></app-svg>
            <span>Order</span>
          </button>
          <div contextContent class="sorting-menu">
            <ng-container *ngTemplateOutlet="galleryOrderTemplate"></ng-container>
          </div>
        </app-context-menu>
      }
    </ng-container>
    <ng-container sectionContent>
      @if (draggingGallery()) {
        <app-gallery-item
          class="dragging-gallery"
          [gallery]="draggingGallery()"
          [darkBackground]="darkBackground"
          [style.left]="draggingGalleryPos().x + 'px'"
          [style.top]="draggingGalleryPos().y + 'px'"
        ></app-gallery-item>
      }
      @if (insertPosition()) {
        <div
          class="insert-position"
          [style.left]="insertPosition().x + 'px'"
          [style.top]="insertPosition().y + 'px'"
          [style.height]="insertPosition().height + 'px'"
        ></div>
      }
      <div class="galleries-page" [class.dark]="darkBackground">
        @if (galleryDropHover()) {
          <div class="gallery-drop-hover"></div>
        }
        @if (links$ | async; as links) {
          @if (galleries.length) {
            <div class="galleries">
              @for (gallery of galleries; track gallery.id) {
                <a [routerLink]="links[gallery.id]">
                  <app-gallery-item
                    [gallery]="gallery"
                    [darkBackground]="darkBackground"
                    (mousedown)="mouseDown($event, gallery)"
                    [id]="'gallery__' + gallery.id"
                    [class.dragging]="draggingGallery()?.id === gallery.id"
                  >
                    <div contentAlways>
                      <app-activity-badge
                        [gallery]="gallery"
                        [hasLink]="true"
                        [noBorder]="true"
                        [hideWhenEmpty]="true"
                        (click)="openActivityMenu($event, activityMenu)"
                      >
                      </app-activity-badge>
                      <app-context-menu
                        class="activity-context"
                        [options]="{ width: '380px', noSpacing: true }"
                        #activityMenu
                      >
                        <div contextContent>
                          @if (activityMenu.isOpen()) {
                            <app-gallery-activity-menu
                              [gallery]="gallery"
                              (closeContext)="activityMenu.close()"
                            ></app-gallery-activity-menu>
                          }
                        </div>
                      </app-context-menu>
                    </div>
                    <div contentOnHover>
                      <app-context-menu
                        [options]="{ width: '240px', noSpacing: true }"
                        #menu
                        [position]="'right'"
                        class="more-button-container"
                        [contextHoverIdentifiers]="['gallery-' + gallery.id, 'section-' + section.id]"
                      >
                        <button
                          appButton
                          name="gallery-options"
                          location="edit-album-section"
                          [iconButton]="true"
                          shape="round"
                          height="1"
                          color="hard-simple"
                          class="more-button"
                          contextButton
                        >
                          <app-svg src="/assets/icons/dots-vertical.svg"></app-svg>
                        </button>
                        <div contextContent>
                          @if (menu.isOpen()) {
                            <app-gallery-context-menu [gallery]="gallery" (onClose)="menu.close()">
                            </app-gallery-context-menu>
                          }
                        </div>
                      </app-context-menu>
                    </div>
                  </app-gallery-item>
                </a>
              }
              @if (galleryPermissions().can_edit) {
                <div class="add-gallery-container">
                  <div class="add-gallery" (click)="addGallery()">
                    @if (!addingGallery()) {
                      <div class="add-gallery-inner">
                        <app-svg src="/assets/icons/gallery-plus.svg"></app-svg>
                        <span>Create Sub-Gallery</span>
                      </div>
                    } @else {
                      <div class="add-gallery-inner">
                        <app-loading-indicator color="primary" size="small" class="button-loading-indicator">
                        </app-loading-indicator>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          } @else if (galleryPermissions().can_edit) {
            <div class="no-galleries">
              <div class="fake-galleries" *onlyForScreens="['desktop', 'tablet']">
                <div class="fake-gallery">
                  <div></div>
                </div>
                <div class="fake-gallery">
                  <div></div>
                </div>
                <div class="fake-gallery">
                  <div></div>
                </div>
                <div class="fake-gallery">
                  <div></div>
                </div>
                <div class="fake-gallery">
                  <div></div>
                </div>
                <div class="fake-gallery">
                  <div></div>
                </div>
              </div>
              <div class="no-galleries-content">
                <img src="/assets/icons/special/gallery-add-{{ darkBackground ? 'light' : 'dark' }}.svg" alt="" />
                <h2>Sub-Galleries</h2>
                <div>Organize your Gallery with Sub-Galleries.</div>
                <button
                  appButton
                  [center]="true"
                  height="0"
                  spacing="1"
                  shape="small"
                  name="add-first-sub-gallery"
                  location="edit-album-section"
                  data-test-id="add-subgallery"
                  (click)="addGallery()"
                  color="simple-primary-opacity"
                >
                  <span [class.hidden-text]="addingGallery()">Create Sub-Gallery</span>
                  @if (addingGallery()) {
                    <app-loading-indicator color="primary" size="small" class="button-loading-indicator">
                    </app-loading-indicator>
                  }
                </button>
              </div>
            </div>
          }
        }
      </div>
    </ng-container>
  </app-section-container>
}

<ng-template #galleryOrderTemplate>
  <h3 class="menu-list-title">GALLERY ORDER</h3>
  @for (sort of sortings; track sort) {
    @if (sort !== 'position' || section.sorting === 'position') {
      <button
        appButton
        [color]="(section.sorting || 'created_at') === sort ? 'simple-primary' : 'hard-simple'"
        class="align-left"
        spacing="1-5"
        height="1"
        name="sorting-{{ sort }}"
        location="edit-album-section"
        (click)="changeGallerySorting(sort)"
      >
        {{ 'section_sorting_' + sort | translate }}
      </button>
    }
  }
  @if (section.sorting !== 'manual') {
    <div class="divider drag-and-drop-info-spacer"></div>
    <p class="info-message drag-and-drop-info">
      <app-svg src="/assets/icons/16/info.svg"></app-svg>
      <span>Drag galleries for manual ordering.</span>
    </p>
  }
</ng-template>
